import React from 'react';

import { useTranslations } from '@unisporkal/localization';

import styles from './LimitedUseProductsForm.module.scss';
import LimitedUseProductsMessage from '../../Messages/LimitedUseProductsMessage/LimitedUseProductsMessage';
import LimitedUseProducts from '../../LimitedUseProducts/LimitedUseProducts';

const LimitedUseProductsForm = () => {
  const t = useTranslations();
  return (
    <div className={styles.container}>
      <LimitedUseProductsMessage />
      <LimitedUseProducts />
      <div className={styles.note}>{t('limited_use_editorial_note')}</div>
    </div>
  );
};

export default LimitedUseProductsForm;
